import _ from 'lodash'

import { typeByObject } from 'utils/typescript'

import { PROPS_OPTIONS, TYPES } from './constants'

export const getProps = (type: typeByObject<typeof TYPES> | undefined) => _.find(PROPS_OPTIONS, ['type', type])
